<h2 mat-dialog-title>Herkunft / Händler setzen</h2>

<mat-dialog-content class="dialog-content">
    <p class="intro">Bitte wählen Sie, was Sie setzen möchten. Standard: nur die Tierliste wird aktualisiert.</p>

    <mat-button-toggle-group
        class="mode-toggle"
        [value]="editMode"
        (change)="setEditMode($event.value)"
        aria-label="Herkunft oder Händler"
    >
        <mat-button-toggle value="herkunft">Herkunft</mat-button-toggle>
        <mat-button-toggle value="handler">Händler</mat-button-toggle>
    </mat-button-toggle-group>

    <ng-container *ngIf="isHerkunftMode">
        <section class="auswahl-section">
            <h3>Herkunftsbetrieb auswählen</h3>
            <kiene-betriebskontakt-auswahl
                [config]="{
                    showLandwirte: true,
                    showHaendler: true,
                    showSchlachthoefe: true,
                    showAll: true,
                    multiSelect: false,
                    compact: true,
                    title: 'Herkunftsbetrieb auswählen',
                    placeholder: 'Betrieb suchen...'
                }"
                [selectedKontakte]="selectedKontakt ? [selectedKontakt] : []"
                (kontaktSelected)="onKontaktSelected($event)"
                (kontakteSelected)="onKontakteSelected($event)"
            >
            </kiene-betriebskontakt-auswahl>
        </section>

        <section *ngIf="selectedKontakt" class="selected-card">
            <h4>Ausgewählter Betrieb</h4>
            <kiene-betriebskontakt-card
                [kontakt]="selectedKontakt"
                [config]="{
                    showActions: false,
                    showMenu: false,
                    showFavorit: false,
                    compact: true,
                    showBadge: false,
                    selectedMode: true
                }"
            >
            </kiene-betriebskontakt-card>
        </section>
    </ng-container>

    <ng-container *ngIf="!isHerkunftMode">
        <section class="auswahl-section">
            <div class="one-row">
                <mat-form-field class="haendler-field">
                    <mat-label>Händler</mat-label>
                    <mat-select
                        [formControl]="haendlerCtrl"
                        [compareWith]="haendlerComparator"
                        (selectionChange)="onHandlerSelected()"
                    >
                        <mat-option *ngFor="let h of haendlerList" [value]="h">{{ h?.name }}</mat-option>
                    </mat-select>
                    <mat-hint>Bitte Händler auswählen</mat-hint>
                </mat-form-field>
                <button
                    type="button"
                    mat-icon-button
                    color="accent"
                    aria-label="Neuen Händler anlegen"
                    (click)="openCreateHaendlerDialog()"
                >
                    <mat-icon>add</mat-icon>
                </button>
            </div>
        </section>
    </ng-container>

    <mat-checkbox class="apply-checkbox" [(ngModel)]="applyToTiere" [disabled]="isSaving || anzahlTiere === 0">
        {{ applyCheckboxLabel }}
    </mat-checkbox>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="cancel()" [disabled]="isSaving">Abbrechen</button>
    <button mat-button color="warn" (click)="clearSelection()" [disabled]="isSaving">
        {{ clearButtonLabel }}
    </button>
    <button mat-flat-button color="primary" (click)="save()" [disabled]="isSaving">
        <mat-spinner *ngIf="isSaving" diameter="20"></mat-spinner>
        <span *ngIf="!isSaving">Speichern</span>
    </button>
</mat-dialog-actions>
